import type { InternalIdProps } from './InternalId.types';

import { FieldName } from '../FieldName';
import { FieldValue } from '../FieldValue';

export const InternalId = ({ document }: InternalIdProps) => {
  if (!document.official_id) {
    return null;
  }

  return (
    <>
      <FieldName>Internal ID</FieldName>
      <FieldValue>{document.official_id}</FieldValue>
    </>
  );
};
